import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { SuiSearchInput } from '@splashthat/sui';
import { colorAppBorder } from 'common/styles/colors';

const SEARCH_PLACEHOLDER = 'Search forms';

const SearchInputContainer = styled.div`
    padding: 0.5rem 7rem;
    border-bottom: 1px solid ${colorAppBorder};
`;

const BASE_COMPONENT_NAME = 'ScaledFormSearchInput';

const ScaledFormSearchInput = ({ onSearch, searchTerm }) => (
    <SearchInputContainer>
        <SuiSearchInput
            fullWidth
            placeholder={SEARCH_PLACEHOLDER}
            data-qa={BASE_COMPONENT_NAME}
            defaultValue={searchTerm}
            onSearch={onSearch}
        />
    </SearchInputContainer>
);

ScaledFormSearchInput.propTypes = {
    onSearch: PropTypes.func.isRequired,
    searchTerm: PropTypes.string.isRequired,
};

export default ScaledFormSearchInput;
